import { useTranslation } from 'next-i18next';
import { type QuizBankFilterOption } from '../types';
import { QuizBankFilterOptionRow } from './QuizBankFilterOptionRow';
interface QuizBankTypeFilterProps {
  options: QuizBankFilterOption[];
  onToggle: (type: string) => void;
}

/** 문제 유형 필터 — MVP 는 객관식 / 단답형 / OX 세 종류. */
export const QuizBankTypeFilter = ({
  options,
  onToggle
}: QuizBankTypeFilterProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <section className="flex flex-col gap-3xs" data-sentry-component="QuizBankTypeFilter" data-sentry-source-file="QuizBankTypeFilter.tsx">
      <h3 className="px-2xs text-body-sm-bold text-alternative">
        {t('build:quizBank.filter.type')}
      </h3>
      <div className="flex flex-col">
        {options.map(option => <QuizBankFilterOptionRow key={option.id} option={option} onToggle={onToggle} />)}
      </div>
    </section>;
};